import { render, staticRenderFns } from "./LocationInfoTab.vue?vue&type=template&id=5645a94e&scoped=true&"
import script from "./LocationInfoTab.vue?vue&type=script&lang=ts&"
export * from "./LocationInfoTab.vue?vue&type=script&lang=ts&"
import style0 from "./LocationInfoTab.vue?vue&type=style&index=0&id=5645a94e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645a94e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
